import getDevice from '@core/js/hooks/device/helpers';
import { allPass } from 'ramda';
import { getJackpot } from '@core/js/hooks/useGetJackpots/helpers';

export const filterGamesByJackpotCodes = (games = {}) => {
    const device = getDevice();
    const handleOtherOs = game => game.osAvailability.includes('other') && device.isOtherOs;
    const handleOtherBrowser = game => game.browserAvailability.includes('other') && device.isOtherBrowser;
    const isOsFits = game => game.osAvailability.includes(device.os) || handleOtherOs(game);
    const isBrowserFits = game => game.browserAvailability.includes(device.browserName) || handleOtherBrowser(game);
    const isFormFactorFits = game => game.deviceAvailability.includes(device.formFactor);
    const isGameFits = allPass([isOsFits, isBrowserFits, isFormFactorFits]);

    return Object.values(games)
        .filter(isGameFits)
        .filter(game => game.jackpotCode);
};

export const formatJackpotsResponse = (jackpots = []) => jackpots.reduce((acc, cur) => ({ ...acc, [cur.GameId]: cur }), {});

export const formatJackpotPayload = (data = {}, games) => {
    const jackpotsMap = {};
    const formattedJackpots = formatJackpotsResponse(data?.Jackpots);

    if (data && data.Jackpots) {
        games.forEach(game => {
            if (formattedJackpots[game.jackpotCode]) {
                const jackpot = formattedJackpots[game.jackpotCode];
                const amount = jackpot.TotalWinAmount / 100;
                const STEP = 0.01; /* Default step, currently step is missing in API */
                const currency = 'CHF';
                const hitTime = null;
                const jackpotGreenTube = getJackpot({ amount, STEP, currency, hitTime });
                jackpotsMap[game.gameCode] = {
                    amount: jackpotGreenTube.amount,
                    hitTime: jackpotGreenTube.hitTime,
                    originAmount: amount,
                    step: STEP,
                    isGreenTube: true
                };
            }
        });
    }

    return jackpotsMap;
};
